import {useEffect, useState} from 'react';
import http from 'services/http';
import {alerta} from '../Alert';

/**
 * Componente bidirecional para gerenciar o vínculo gerente ↔ loteria.
 *
 * @param {Object} props
 * @param {'gerente' | 'loteria'} props.tipo - Qual lado está sendo editado
 * @param {number} props.id - ID do gerente OU da loteria
 */
export default function VinculoGerenteLoteria({tipo, id}) {
    const [itens, setItens] = useState([]);
    const [loading, setLoading] = useState(true);
    const [salvando, setSalvando] = useState(false);

    const endpoints = tipo === 'gerente'
        ? {
            get: `/usuarios/${id}/loterias-acesso`,
            put: `/usuarios/${id}/loterias-acesso`,
            chaveBody: 'loteria_ids',
            chaveFlag: 'vinculada',
            chaveLabel: (item) => `${item.hora?.slice(0, 5) ?? ''} - ${item.nome}`,
            titulo: 'Extrações',
            hint: 'Marque as extrações que os cambistas deste gerente terão acesso. Se nenhuma estiver marcada, os cambistas não verão nenhuma extração.',
        }
        : {
            get: `/loterias/${id}/gerentes`,
            put: `/loterias/${id}/gerentes`,
            chaveBody: 'gerente_ids',
            chaveFlag: 'vinculado',
            chaveLabel: (item) => item.login,
            titulo: 'Gerentes',
            hint: 'Marque os gerentes que terão acesso a esta extração. Cambistas de gerentes não marcados NÃO verão esta extração.',
        };

    useEffect(() => {
        const carregar = async () => {
            try {
                setLoading(true);
                const {data} = await http.get(endpoints.get);
                setItens(data.data ?? []);
            } catch (e) {
                alerta(e.response?.data ?? {success: false, message: 'Erro ao carregar'});
            } finally {
                setLoading(false);
            }
        };
        if (id) carregar();
    }, [id, tipo]);

    const toggle = (itemId) => {
        setItens(itens.map(it => it.id === itemId ? {...it, [endpoints.chaveFlag]: !it[endpoints.chaveFlag]} : it));
    };

    const marcarTodos = () => {
        setItens(itens.map(it => ({...it, [endpoints.chaveFlag]: true})));
    };

    const desmarcarTodos = () => {
        setItens(itens.map(it => ({...it, [endpoints.chaveFlag]: false})));
    };

    const salvar = async () => {
        try {
            setSalvando(true);
            const ids = itens.filter(it => it[endpoints.chaveFlag]).map(it => it.id);
            const response = await http.put(endpoints.put, {[endpoints.chaveBody]: ids});
            alerta(response.data);
        } catch (e) {
            alerta(e.response?.data ?? {success: false, message: 'Erro ao salvar'});
        } finally {
            setSalvando(false);
        }
    };

    if (loading) return <div className="loader" />;

    const totalMarcados = itens.filter(it => it[endpoints.chaveFlag]).length;

    return (
        <div className="conteudo-principal">
            <div style={{padding: '10px', background: '#fff3cd', border: '1px solid #ffc107', borderRadius: 4, fontSize: 12, marginBottom: 12}}>
                ⚠️ {endpoints.hint}
            </div>

            <div style={{display: 'flex', gap: 8, marginBottom: 10, alignItems: 'center'}}>
                <button type="button" className="btn btn-sm btn-secondary" onClick={marcarTodos}>
                    Marcar todos
                </button>
                <button type="button" className="btn btn-sm btn-secondary" onClick={desmarcarTodos}>
                    Desmarcar todos
                </button>
                <span style={{marginLeft: 'auto', fontSize: 13}}>
                    <b>{totalMarcados}</b> de <b>{itens.length}</b> marcados
                </span>
            </div>

            {itens.length === 0 ? (
                <p style={{color: '#999'}}>Nenhum {endpoints.titulo.toLowerCase()} encontrado.</p>
            ) : (
                <div style={{maxHeight: 400, overflowY: 'auto', border: '1px solid #ddd', borderRadius: 4, padding: 10}}>
                    {itens.map((item) => (
                        <label key={item.id} style={{display: 'flex', alignItems: 'center', gap: 8, padding: '6px 4px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0'}}>
                            <input
                                type="checkbox"
                                checked={!!item[endpoints.chaveFlag]}
                                onChange={() => toggle(item.id)}
                            />
                            <span>{endpoints.chaveLabel(item)}</span>
                        </label>
                    ))}
                </div>
            )}

            <div className="d-flex m-t" style={{justifyContent: 'flex-end'}}>
                <button type="button" className="btn btn-success" onClick={salvar} disabled={salvando}>
                    {salvando ? 'Salvando...' : 'Salvar vínculo'}
                </button>
            </div>
        </div>
    );
}
